import { render, staticRenderFns } from "./ImportApprovals.vue?vue&type=template&id=2c692df2&"
import script from "./ImportApprovals.vue?vue&type=script&lang=js&"
export * from "./ImportApprovals.vue?vue&type=script&lang=js&"
import style0 from "./ImportApprovals.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports